<template>
    <div class="kpi-social mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
        <template v-if="!!missed_accounts.length">
            <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
        </template>
        <h4 class="section-name my-3 text-uppercase">{{kpiData.name}}</h4>
        <div v-if="!reloading && !errors" class="row row-cols-1 row-cols-md-2 justify-content-center">
            <div v-if="inst_num_metrics > 0 && has_values['instagram']" class="col d-flex flex-column justify-content-center double-social-kpi social-box">
                <div class="kpi-wrap py-35 px-2 flex-grow-1 inst my-1" :class="[{'single':inst_num_metrics==1}, {'double':inst_num_metrics==2}, {'triple':inst_num_metrics==3}]">
                    <img :src="`${$store.state.app_url}images/social/camera.png`" />
                    <div class="row pl-5 ml-1 justify-content-center" :class="'row-cols-'+inst_num_metrics">
                        <div v-for="(metric, idx) in inst_metrics" class="col d-flex flex-column justify-content-center" :class="{'pl-5':idx==0}">
                            <template v-if="show_compare">
                                <p class="card-value text-left p-0 m-0" :class="{'arrows':show_arrows}">{{metric.final_value1}}<span v-if="show_arrows" class="amount" :class="metric.cls">{{metric.amount}}</span></p>
                                <p class="card-value text-left p-0 m-0 compare">({{metric.final_value2}})</p>
                            </template>
                            <template v-else>
                                <p class="card-value text-left p-0 m-0" :class="{'arrows':show_arrows}">{{metric.final_value1}}<span v-if="show_arrows" class="amount" :class="metric.cls">{{metric.amount}}</span></p>
                            </template>
                            <p class="metric arrow text-left p-0 m-0">{{metric.metric_name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="fb_num_metrics > 0 && has_values['facebook']" class="col d-flex flex-column justify-content-center double-social-kpi social-box">
                <div class="kpi-wrap py-35 px-2 flex-grow-1 fb my-1" :class="[{'single':fb_num_metrics==1}, {'double':fb_num_metrics==2}, {'triple':fb_num_metrics==3}]">
                    <img :src="`${$store.state.app_url}images/social/fb.png`" />
                    <div class="row pl-3 ml-0 justify-content-center" :class="'row-cols-'+fb_num_metrics">
                        <div v-for="(metric, idx) in fb_metrics" class="col d-flex flex-column justify-content-center my-1" :class="{'pl-5':idx==0}">
                            <template v-if="show_compare">
                                <p class="card-value text-left p-0 m-0" :class="{'arrows':show_arrows}">{{metric.final_value1}}<span v-if="show_arrows" class="amount" :class="metric.cls">{{metric.amount}}</span></p>
                                <p class="card-value text-left p-0 m-0 compare">({{metric.final_value2}})</p>
                            </template>
                            <template v-else>
                                <p class="card-value text-left p-0 m-0" :class="{'arrows':show_arrows}">{{metric.final_value1}}<span v-if="show_arrows" class="amount" :class="metric.cls">{{metric.amount}}</span></p>
                            </template>
                            <p class="metric arrow text-left p-0 m-0">{{metric.metric_name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="linkedin_num_metrics > 0 && has_values['linkedin']" class="col d-flex flex-column justify-content-center double-social-kpi social-box">
                <div class="kpi-wrap py-35 px-2 flex-grow-1 linkedin my-1" :class="[{'single':linkedin_num_metrics==1}, {'double':linkedin_num_metrics==2}, {'triple':linkedin_num_metrics==3}]">
                    <img :src="`${$store.state.app_url}images/social/linkedin.png`" />
                    <div class="row pl-5 ml-1 justify-content-center" :class="'row-cols-'+linkedin_num_metrics">
                        <div v-for="(metric, idx) in linkedin_metrics" class="col d-flex flex-column justify-content-center my-1" :class="{'pl-5':idx==0}">
                            <template v-if="show_compare">
                                <p class="card-value text-left p-0 m-0" :class="{'arrows':show_arrows}">{{metric.final_value1}}<span v-if="show_arrows" class="amount" :class="metric.cls">{{metric.amount}}</span></p>
                                <p class="card-value text-left p-0 m-0 compare">({{metric.final_value2}})</p>
                            </template>
                            <template v-else>
                                <p class="card-value text-left p-0 m-0" :class="{'arrows':show_arrows}">{{metric.final_value1}}<span v-if="show_arrows" class="amount" :class="metric.cls">{{metric.amount}}</span></p>
                            </template>
                            <p class="metric arrow text-left p-0 m-0">{{metric.metric_name}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="errors">
            <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['kpiData', 'hasSkb'],
        created(){
            this.show_arrows = this.kpiData.element_configurations.show_arrows;
            this.show_compare = this.kpiData.element_configurations.show_comparison;
            this.fetchServerData();
            this.missed_accounts = this.checkAccounts(this.kpiData);
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                instSocial:'inst',
                fbSocial:'fb',
                linkedinSocial:'linkedin',
                fb_num_metrics:null,
                inst_num_metrics:null,
                linkedin_num_metrics:null,
                fb_metrics:null,
                inst_metrics:null,
                linkedin_metrics:null,
                has_values:{'facebook':false, 'instagram':false, 'linkedin':false},
                missed_accounts:[],
                show_arrows:false,
                show_compare:false,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.kpiData.archive_id : this.kpiData.report_id,
                    'element_abbr':this.kpiData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.kpiData.element_id,
                    'prefixed_element_id': this.kpiData.report_element_id,
                    'element_name': this.kpiData.name,
                    'metrics': this.kpiData.metrics,
                    'accounts': this.kpiData.accounts,
                    'show_arrows':this.show_arrows,
                    'show_compare':this.show_compare,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        this.query = response.data.query;
                        this.errors = response.data.errors;
                        if(!this.errors){
                            this.fb_metrics = response.data['boxes_data']['facebook'];
                            this.inst_metrics = response.data['boxes_data']['instagram'];
                            this.linkedin_metrics = response.data['boxes_data']['linkedin'];
                            this.fb_num_metrics = Object.keys(this.fb_metrics).length;
                            this.inst_num_metrics = Object.keys(this.inst_metrics).length;
                            this.linkedin_num_metrics = Object.keys(this.linkedin_metrics).length;
                            this.has_values['facebook'] = response.data['has_values']['facebook'];
                            this.has_values['instagram'] = response.data['has_values']['instagram'];
                            this.has_values['linkedin'] = response.data['has_values']['linkedin'];
                        }
                    }
                    this.reloading = false;
                });
            },
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.kpi-wrap{
        border-radius:2rem;
        position:relative;
        p.card-value{
            position:relative;
            display:inline-block;
            font-family:'Chronicle Display Extra Light';
            font-size:6rem;
            @media screen and (max-width: 992px) {
                font-size:3rem !important;
            }
            @media screen and (max-width: 500px) {
                font-size:2.5rem !important;
            }
            line-height:5rem;
            span.amount {
                position: relative;
                display:inline-block;
                text-align: left;
                vertical-align: middle;
                margin-left:3rem;
                &::before {
                    border-left: 1.5rem solid transparent;
                    border-right: 1.5rem solid transparent;
                    content: "";
                    display: inline-block;
                    height: 0;
                    width: 0;
                    margin-right:1rem;
                }
            }
            &.arrows{
                font-size:3rem;
                line-height:3rem;
                margin-left:1rem;
                span.amount{
                    font-size:1.8rem;
                }
            }
            &.compare{
                font-size:1.8rem;
                line-height:3rem;
            }
        }
        &.inst{
            border:0.2rem solid $gold;
            color:$gold;
            p.card-value{
                span.amount {
                    &.up{
                        &::before {
                             border-bottom: 1.2rem dashed $gold;
                         }
                    }
                    &.down{
                        &::before {
                             border-top: 1.2rem dashed $gold;
                         }
                    }
                }
            }
        }
        &.fb{
            border:0.2rem solid $black-blue;
            color:$black-blue;
            p.card-value{
                span.amount {
                    &.up{
                        &::before {
                            border-bottom: 1.2rem dashed $black-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 1.2rem dashed $black-blue;
                        }
                    }
                }
            }
        }
        &.linkedin{
            border:0.2rem solid $linkedin_border;
            color:$linkedin_border;
            p.card-value{
                span.amount {
                    &.up{
                        &::before {
                            border-bottom: 1.2rem dashed $linkedin_border;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 1.2rem dashed $linkedin_border;
                        }
                    }
                }
            }
        }
        img{
            position:absolute;
            left:2rem;
            top:calc(50% - 3rem);
            height:6rem;
        }

        p.arrow{
            margin-right:1.2vw !important;
        }
        &.triple{
            p.card-value{
                font-size:3vw;
                line-height:2.8vw;
                span.amount {
                    font-size:1vw;
                    text-align: left;
                    margin-left:0.5vw;
                    &::before {
                        border-left: 0.8vw solid transparent;
                        border-right: 0.8vw solid transparent;
                        margin-right:0.5vw;
                    }
                    &.up{
                        &::before {
                            border-bottom-width: 0.7vw;
                            margin-bottom:0.5vw;
                        }
                    }
                    &.down{
                        &::before {
                            border-top-width: 0.7vw;
                            margin-bottom:0.5vw;
                        }
                    }
                }
                &.arrows{
                    font-size:2.4vw;
                    line-height:2vw;
                    span.amount {
                        font-size:0.6vw;
                        margin-left:0.1vw;
                        &.up{
                            &::before {
                                margin-bottom:0;
                            }
                        }
                        &.down{
                            &::before {
                                margin-bottom:0;
                            }
                        }
                    }
                }
                &.compare{
                    font-size:1.2vw;
                    line-height:1.4vw;
                }
            }
        }
        .social-box{
            @media screen and (max-width: 992px) {
                padding-left:0 !important;
                padding-right:0 !important;
            }
        }
    }
</style>
